// @ts-check
import Tl from 'localization/LocalizationKeys';

/**
 * @readonly
 * @enum {string}
 */
const Operator = {
  EQUAL: 'equal',
  NOT_EQUAL: 'not_equal',
  GREATER_THAN: 'greater_than',
  LESS_THAN: 'less_than',
  GREATER_THAN_OR_EQUAL: 'greater_than_or_equal',
  LESS_THAN_OR_EQUAL: 'less_than_or_equal'
};

/**
 * @readonly
 * @type {Record<Operator, string>}
 */
export const OperatorTranslation = {
  [Operator.EQUAL]: '=',
  [Operator.NOT_EQUAL]: '<>',
  [Operator.GREATER_THAN]: '>',
  [Operator.LESS_THAN]: '<',
  [Operator.GREATER_THAN_OR_EQUAL]: '>=',
  [Operator.LESS_THAN_OR_EQUAL]: '<='
};

/**
 * @readonly
 * @enum {string}
 */
export const LogicalOperator = {
  AND: 'AND',
  OR: 'OR'
};

/**
 * @readonly
 * @enum {string}
 */
export const LogicalOperatorTranslation = {
  [LogicalOperator.AND]: Tl.common.logicalOperator.and,
  [LogicalOperator.OR]: Tl.common.logicalOperator.or
};

export default Operator;
